import { ComponentProps } from 'react';
import EUR from './currencies/EUR.svg';
import USD from './currencies/USD.svg';
import GBP from './currencies/GBP.svg';
import EURA from './currencies/EURA.png';
import EURT from './currencies/EURT.svg';
import USDT from './currencies/USDT.svg';
import USDC from './currencies/USDC.svg';
import EURC from './currencies/EURC.svg';
import BTC from './currencies/BTC.svg';
import TRX from './currencies/TRX.svg';
import ETH from './currencies/ETH.svg';
import BNB from './currencies/BNB.svg';
import MATIC from './currencies/MATIC.svg';
import ADA from './currencies/ADA.svg';
import XTZ from './currencies/XTZ.svg';
import ATOM from './currencies/ATOM.svg';
import ISLM from './currencies/ISLM.svg';
import TON from './currencies/TON.svg';
import ARB from './currencies/ARB.svg';
import SOL from './currencies/SOL.svg';
import CHF from './currencies/CHF.svg';
import CNY from './currencies/CNY.svg';
import AED from './currencies/AED.svg';
import NPC from './currencies/NPC.png';
import DOGE from './currencies/DOGE.svg';
import PEPE from './currencies/PEPE.svg';
import SHIB from './currencies/SHIB.svg';
import XRP from './currencies/XRP.svg';
import TRUMP from './currencies/TRUMP.png';

export interface CurrencyImageProps extends Omit<ComponentProps<'img'>, 'src' | 'srcSet'> {
  currency: string;
}

export const currencyImages: Record<string, string | undefined> = {
  USD,
  EUR,
  GBP,
  BTC,
  EURA,
  EURT,
  USDT,
  USDC,
  EURC,
  TRX,
  ETH,
  BNB,
  MATIC,
  ADA,
  XTZ,
  ATOM,
  ISLM,
  TON,
  ARB,
  SOL,
  CHF,
  CNY,
  AED,
  NPC,
  DOGE,
  PEPE,
  SHIB,
  XRP,
  TRUMP,
};

export function CurrencyImage({ currency, alt, ...props }: CurrencyImageProps) {
  const src = currencyImages[currency];

  return src ? <img src={src} alt={alt ?? currency} {...props} /> : null;
}
